<template>
  <div>
    <div>
      <v-layout wrap>
        <v-flex xs6 style="display: flex" align-center
          ><h3>{{ $t('cenni_connect.title') }}</h3></v-flex
        >
        <v-flex xs6 style="display: flex" justify-end> </v-flex>
      </v-layout>
    </div>

    <div>
      <v-layout wrap class="my-3" style="display: flex; align-items: center">
        <v-flex xs6>{{ $t('cenni_connect.enable') }}</v-flex>
        <v-flex xs6 class="text-xs-right">
          <ToggleButton
            :value="input.is_enable"
            :sync="true"
            :color="$vuetify.theme.success"
            :labels="{ checked: 'ON', unchecked: 'OFF' }"
            style="display: inline-block"
            @change="handleChangeConfig"
          />
        </v-flex>
      </v-layout>
    </div>
    <div class="pt-2">
      <v-layout wrap style="display: flex; align-items: center">
        <v-flex xs6>{{ $t('cenni_connect.bot_config') }}</v-flex>
        <v-flex xs6 class="text-xs-right">
          <v-btn fab outline color="primary" class="extra-small ma-1" @click="handleEdit">
            <i class="fas fa-pencil-alt"></i>
          </v-btn>
        </v-flex>
      </v-layout>
    </div>
    <div
      :style="{
        border: `1px solid ${$vuetify.theme.primary}`
      }"
      class="pa-3 my-3"
    >
      <div class="form-control">
        <div class="caption mb-1 mt-2">{{ $t('cenni_connect.api_secret') }}</div>
        <input
          v-model="input.api_secret"
          type="text"
          :placeholder="$t('cenni_connect.api_secret')"
          class="form-control"
          maxlength="255"
          :disabled="!isEdit"
        />
      </div>
      <div class="form-control">
        <div class="caption mb-1 mt-2">{{ $t('cenni_connect.api_url') }}</div>
        <input
          v-model="input.api_url"
          type="text"
          :placeholder="$t('cenni_connect.api_url')"
          class="form-control"
          maxlength="255"
          :disabled="!isEdit"
        />
      </div>
    </div>

    <template v-if="isEdit === true">
      <div class="text-xs-center mt-3">
        <v-btn outline color="grey" :loading="saveLoading" @click="handleCancel">{{
          $t('cancel')
        }}</v-btn>
        <v-btn color="primary" depressed :loading="saveLoading" @click="handleSubmit">{{
          $t('Save')
        }}</v-btn>
      </div>
    </template>
  </div>
</template>

<script>
import cmsConfig from '@/api/config'
import { mapGetters } from 'vuex'
import { ToggleButton } from 'vue-js-toggle-button'

export default {
  components: {
    ToggleButton
  },
  data() {
    return {
      input: {
        is_enable: false,
        api_secret: '',
        api_url: ''
      },
      isEdit: false,
      cacheData: null,
      saveLoading: false
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  watch: {
    selectedBot(data) {
      this.handlePrefillForm(data)
    }
  },
  async mounted() {
    await this.$store.dispatch('updateBotDetail')
  },
  methods: {
    handlePrefillForm(data) {
      try {
        const tempData = data.page_custom_attributes_json

        this.cacheData = tempData
        this.input.is_enable = tempData.cenni_bot_config.is_enable || false
        this.input.api_secret = tempData.cenni_bot_config.api_secret
        this.input.api_url = tempData.cenni_bot_config.api_url
      } catch (error) {
        console.error(error)
      }
    },
    handleEdit() {
      this.isEdit = true
    },
    handleCancel() {
      this.isEdit = false
      this.input = {
        is_enable: this.cacheData.cenni_bot_config.is_enable,
        api_secret: this.cacheData.cenni_bot_config.api_secret,
        api_url: this.cacheData.cenni_bot_config.api_url
      }
    },
    async handleChangeConfig() {
      try {
        this.$store.dispatch('loading')
        const response = await cmsConfig.updatePageCustomAttributes({
          params: {
            pageId: this.selectedBot.pageid
          },
          data: {
            page_custom_attributes_json: {
              ...this.cacheData,
              cenni_bot_config: {
                ...this.cacheData.cenni_bot_config,
                is_enable: !this.input.is_enable
              }
            }
          }
        })
        const { status } = response
        if (status === 204) {
          this.$swal.fire({
            type: 'success',
            title: this.$t('Success')
          })
        }
      } catch (error) {
        console.error(error)
        this.$swal.fire({
          type: 'error',
          title: this.$t('Unsuccessful')
        })
      } finally {
        this.$store.dispatch('updateBotDetail')
        this.$store.dispatch('loading')
      }
    },
    async handleSubmit() {
      const vm = this
      try {
        vm.$store.dispatch('loading')
        const response = await cmsConfig.updatePageCustomAttributes({
          params: {
            pageId: vm.selectedBot.pageid
          },
          data: {
            page_custom_attributes_json: {
              ...vm.cacheData,
              cenni_bot_config: {
                api_secret: vm.input.api_secret,
                api_url: vm.input.api_url
              }
            }
          }
        })
        const { status } = response
        if (status === 204) {
          vm.$swal.fire({
            type: 'success',
            title: vm.$t('Success')
          })
        }
      } catch (error) {
        console.error(error)
        vm.$swal.fire({
          type: 'error',
          title: vm.$t('Unsuccessful')
        })
      } finally {
        vm.$store.dispatch('updateBotDetail')
        vm.$store.dispatch('loading')
        vm.isEdit = false
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/billing/CenniConnectManagement.vue